/* global axios */
import ApiClient from 'dashboard/api/ApiClient';

class SocialAPI extends ApiClient {
  constructor() {
    super('social', { accountScoped: true });
  }

  getAccounts() {
    return axios.get(`${this.url}/connected_accounts`);
  }

  connectAccount(platform) {
    return axios.post(`${this.url}/connected_accounts/connect`, { platform });
  }

  getPosts(params = {}) {
    return axios.get(`${this.url}/posts`, { params });
  }

  createPost(data) {
    return axios.post(`${this.url}/posts`, { post: data });
  }

  deletePost(id) {
    return axios.delete(`${this.url}/posts/${id}`);
  }

  uploadMedia(formData) {
    return axios.post(`${this.url}/media`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }
}

export default new SocialAPI();
